<template>
  <div>
    <div class="cover-table">
      <Table
        border
        style="width: 100%;"
        :loading="loading"
        :columns="tableColumns"
        :data="tableData"
        highlight-row
      >
        <!-- <template slot-scope="{ row, index }" slot="action">
                    <span class="pointer" @click="handleDeal('projectDetail',row.id)">详情</span>
                </template> -->
      </Table>
    </div>
  </div>
</template>
<script>
import tableTwoMixin from "@/components/tableTwoMixin";
export default {
  mixins: [tableTwoMixin],
  data() {
    return {
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          fixed: "left",
          align: "center",
        },
        {
          title: "项目编号",
          key: "projectId",
          minWidth: 100,
          tooltip: true,
          align: "center",
        },
        {
          title: "工人所属企业统一社会信用代码",
          key: "corpCode",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "工人所属企业名称",
          key: "corpName",
          minWidth: 180,
          tooltip: true,
          align: "center",
        },
        {
          title: "证件类型",
          key: "iDCardType",
          minWidth: 140,
          tooltip: true,
          align: "center",
        },
        {
          title: "证件号码",
          key: "iDCardNumber",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "合同期限类型",
          key: "contractPeriodType",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "生效日期",
          key: "startDate",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "失效日期",
          key: "endDate",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        // { title: '参建班组', key: 'teamName', minWidth: 210, tooltip: true },
        {
          title: "计量单位",
          key: "unit",
          align: "center",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: "计量单价",
          key: "unitPrice",
          minWidth: 140,
          tooltip: true,
          align: "center",
        },
        {
          title: "合同附件",
          key: "attachments",
          align: "center",
          minWidth: 210,
          tooltip: true,
        },
        {
          title: "数据来源",
          key: "projectAreaCode",
          align: "center",
          minWidth: 140,
        },
      ],
    };
  },
};
</script>
